import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import BasicText from '../../Theme/Fonts/BasicText'
import emojiStyling from './Styling'

export enum EmojiTypes {
    EXTRA_SAD,
    SAD,
    NEUTRAL,
    HAPPY,
    EXTRA_HAPPY,
    THUMBS_UP,
}

type BaseEmojiProps = {
    /**
     * emoji type
     *
     * @TJS-type: PropsMap
     */
    type: EmojiTypes
    /**
     *  callback when emoji was clicked
     *
     *  @TJS-type function
     */
    onPress?: () => void
    /**
     * sets size of emoji / borderRadius
     */
    size?: 'M' | 'L'
}

export type EmojiPropsWithBackground = BaseEmojiProps & {
    /**
     * adds borderRadius and backgroundColor
     */
    withBackground: true
    /**
     * adds borderColor, only works with "withBackground"
     */
    selected?: boolean
}

export type EmojiPropsWithoutBackground = BaseEmojiProps & {
    /**
     * adds borderRadius and backgroundColor
     */
    withBackground?: boolean
    /**
     * adds borderColor, only works with "withBackground"
     */
    selected?: never
}

export const EmojiMap: Map<EmojiTypes, string> = new Map<EmojiTypes, string>([
    [EmojiTypes.EXTRA_SAD, '😫'],
    [EmojiTypes.SAD, '🙁'],
    [EmojiTypes.NEUTRAL, '😐'],
    [EmojiTypes.HAPPY, '🙂'],
    [EmojiTypes.EXTRA_HAPPY, '😃'],
    [EmojiTypes.THUMBS_UP, '👍🏼'],
])

const Emoji: FunctionComponent<EmojiPropsWithBackground | EmojiPropsWithoutBackground> = ({
    type,
    withBackground,
    selected,
    onPress,
    size = 'M',
}) => {
    const isMedium = size === 'M'
    const fontSize = isMedium ? 'FS28' : 'FS48'
    const lineHeight = isMedium ? 'LH34' : 'LH58'
    const emoji = (
        <BasicText fontSize={fontSize} lineHeight={lineHeight} textAlign="center">
            {`${EmojiMap.get(type)}`}
        </BasicText>
    )
    let component: ReactElement = emoji
    if (onPress) {
        component = <Touchable onPress={onPress}>{emoji}</Touchable>
    }
    if (withBackground) {
        return (
            <Grid
                {...emojiStyling}
                noExpand
                paddingLeft="0.5px"
                width={isMedium ? 44 : 64}
                height={isMedium ? 44 : 64}
                borderRadius={isMedium ? 22 : 32}
                backgroundColor="tahitian"
                center
                border={selected ? 1 : 0}
                borderColor={selected ? 'onyx' : undefined}
            >
                {component}
            </Grid>
        )
    }
    return component
}

export default Emoji
